import React from 'react';
var ThemeContext = React.createContext(null);
export var ThemeContextProvider = ThemeContext.Provider;
export var ThemeContextConsumer = ThemeContext.Consumer;
